import { GameRoomState } from "@presidents/game-engine";

type PlayersMap = { [key: string]: GameRoomState["players"][number] };

export const createPlayerMap = (
  players?: GameRoomState["players"]
): PlayersMap => {
  if (!players) {
    return {};
  }
  return players.reduce((obj, player) => {
    obj[player.id] = player;
    return obj;
  }, {} as PlayersMap);
};
